






































































import { Inject, Prop, Ref, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { v4 as uuid } from 'uuid'
import { AttachmentAPI, ReferralAPI } from '@/api/backend-client'
import { Attachment } from '@/api/model/attachment'
import VueUploadComponent from 'vue-upload-component'
import reduce from 'image-blob-reduce'
import { escapeHtml } from '@/helpers/html'
const reducer = reduce()

// Override createBlob to product lower quality images.
reducer._create_blob = async function(env) {
    env.out_blob = await this.pica.toBlob(env.out_canvas, 'image/jpeg', 0.5)
    return env
}

@Component
export default class FormAppraisalEnrichDetail extends Vue {
    @Inject() readonly reloadData!: () => void
    @Prop({ required: true }) readonly referral!: Referral
    @Ref() upload!: VueUploadComponent
    @Ref() summary!: HTMLDivElement
    saving: boolean = false
    uploadingIndex: number = 0
    files: VUFile[] = []
    minified: File[] = []
    previews: string[] = []
    scrollTimeout: any = null

    removeFile(file: VUFile): void {
        this.upload.remove(file)
    }

    onFileInput(file: VUFile) {
        if (!file) {
            return
        }

        // This needs to be pushed to next tick or Vue wont pick them up for rendering.
        this.$nextTick(() => this.optimizeImage(file))
        // this.$nextTick(() => this.summary.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' }))

        clearTimeout(this.scrollTimeout)
        this.scrollTimeout = setTimeout(() => this.summary.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'end',
        }), 200)
    }

    async optimizeImage(file: VUFile): Promise<void> {
        const thumbnail = await reducer.toBlob(file.file, { max: 512 })
        const reader = new FileReader()
        reader.onloadend = () => thumbnail[file.id] = reader.result
        reader.readAsDataURL(thumbnail)
        Vue.set(this.minified, file.id, new File([thumbnail], file.name))
        Vue.set(this.previews, file.id, URL.createObjectURL(this.minified[file.id]))
    }

    async removeExistingFile(attachment: Attachment): Promise<void> {
        await AttachmentAPI.delete(attachment.id)
        await this.reloadData()
    }

    async finalizeForm(): Promise<void> {
        this.saving = true
        this.uploadingIndex = 0

        try {
            for (const file of this.files) {
                this.uploadingIndex++
                await AttachmentAPI.create({
                    referral: this.referral,
                    id: uuid(),

                    // @ts-ignore -- hijacking internal object for storing category
                    description: file.category,
                    source: 'form-appraisal',
                    uploadedByContact: true,
                    file: this.minified[file.id],
                })
            }

            await ReferralAPI.updateExtendedAppraisal(this.referral.id)
            await this.reloadData()
            await this.$router.push({
                name: 'form_appraisal_enrich_completed',
            })

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.saving = false
        }
    }

    get categoryOptions() {
        return [
            'Tuin / buiten',
            'Woonkamer',
            'Slaapkamer',
            'Keuken',
            'Badkamer',
            'Toilet',
            'Zolder',
            'Overig',
        ].map(category => ({
            label: category,
            value: category,
        }))
    }

    get existingFiles(): Attachment[] {
        return this.referral.attachments
            .filter(attachment => attachment.uploadedByContact)
            .filter(attachment => attachment.source === 'form-appraisal')
    }
}
